const steps = [
  {
    num: "01",
    title: "Diagnóstico de Governança e Dinâmica Societária",
    desc: "Identificamos onde o conflito realmente nasce, por que ele se repete e como afeta decisões, poder e execução.",
  },
  {
    num: "02",
    title: "Sessões de Intermediação e Alinhamento entre Sócios",
    desc: "Mediação estruturada entre sócios, com escuta ativa, confronto construtivo e foco em decisões estratégicas.",
  },
  {
    num: "03",
    title: "Revisão e Formalização de Acordos Societários",
    desc: "Regras claras, responsabilidades definidas e proteção patrimonial.",
  },
  {
    num: "04",
    title: "Novo Modelo Decisório e Rituais de Governança",
    desc: "Rituais de governança, fóruns claros de decisão, processos que reduzem fricção e ambiguidade. Acompanhamento na transição.",
  },
];

const ApproachSection = () => (
  <section className="bg-background py-14 md:py-20">
    <div className="container mx-auto px-6">
      <div className="text-center mb-14">
        <p className="text-primary font-body font-semibold tracking-widest uppercase text-[13px] mb-5">Método</p>
        <h2 className="text-[25px] md:text-[31px] lg:text-[39px] font-heading font-bold leading-[1.2em] tracking-[-1px]">Nossa Abordagem em 4 Etapas</h2>
      </div>
      <div className="grid sm:grid-cols-2 gap-5 max-w-5xl mx-auto">
        {steps.map((step) => (
          <div key={step.num} className="border border-border rounded-lg p-7 bg-card hover:border-primary/40 transition-colors group">
            <span className="text-[39px] font-heading font-bold text-primary/30 group-hover:text-primary/60 transition-colors leading-[1em]">{step.num}</span>
            <h3 className="font-heading text-[20px] font-bold leading-[1.4em] tracking-[-0.5px] mt-3 mb-3 text-card-foreground">{step.title}</h3>
            <p className="font-body text-muted-foreground text-[14px] font-normal leading-[1.5em]">{step.desc}</p>
          </div>
        ))}
      </div>
      <p className="text-center mt-10 text-muted-foreground font-body italic text-[14px] leading-[1.5em]">
        Para que o conflito não volte disfarçado de "opinião".
      </p>
    </div>
  </section>
);

export default ApproachSection;
